import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/philosophy.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }

import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sub3',
  setup(__props) {

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "etc",
      subtitle: "etc",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"body_content sub\" data-v-ef7b7b3c><h1 class=\"sub_subject\" data-v-ef7b7b3c>철학<span data-v-ef7b7b3c></span></h1><div class=\"sub0102_wrap\" data-v-ef7b7b3c><div class=\"box02 box03\" data-v-ef7b7b3c><h1 data-v-ef7b7b3c>철학</h1><h2 data-v-ef7b7b3c> “코코랩COKOLab”이란 회사명칭은 시대 정신을 기반으로 하는 회사의 설립 배경과 핵심 가치를 담고 있습니다. “COKOLab”은 COnnectome based Knowledge Organization Laboratory의 약어로, 21C를 움직이는 키워드의 합성어입니다. 인간의 뇌신경지도를 일컫는 &#39;Connectome&#39;은 ‘개인 스스로 자신의 뇌신경계를 만들어간다’는 의미를 담고 있습니다. AI 기술의 핵심 개념이기도 합니다. &#39;Knowledge Organization&#39;은 Connectome의 성장 기제로, &#39;Knowledge&#39;는 생존 도구로서의 지식을, &#39;Organization&#39;은 변화에 적응하기 위한 자발적 창발 활동을 뜻합니다. 이 둘의 결합이 &#39;Connectome&#39;을 만들어갑니다. 이 개념들은 21C 핵심 가치로 미래 사회의 진화 패러다임을 규정짓습니다. 끝으로, &#39;Laboratory&#39;는 코코랩이 개인의 창조적 진화를 지원하기 위해 끊임없이 연구, 성장, 진화하겠다는 약속입니다. </h2><h2 data-v-ef7b7b3c> 코코랩은 성장기 학생의 창조 역량을 진단하고 교육하기 위한 목적으로 설립되었습니다. 코코랩은 분야 최고 전문가들의 전문성, 연구 경험, 특별한 교육 철학을 근간으로, 그리고, 설립자의 지난 30여 년 동안의 경험 - 미국 영재교육 현장 장기 체류 경험, 창의적 성취 연구 경험, 국가 영재교육기관 지원 경험을 바탕으로 조직되었습니다. 학문적으로는 성장기 학생이 지금 살고 있는 현재와 앞으로 살아갈 미래를 관통하는 시대 정신, 즉, 복잡계, 세상의 생명체설, 지식의 생명체설, 진화론, 게놈, 양자역학, 다원적 우주론, 자기조직화, 인지과학, 그리고 커넥톰 등을 배경으로 하고 있습니다. 궁극적으로, 코코랩은 개인의 창조적 진화를 반영하는 역량시스템을 구축하여 성장기 학생들에게 자기 이해 기회, 나아가, 스스로 역량을 최적화, 극대화, 고도화하는 기회를 제공함으로써, 그들이 창조적 삶을 만들어가는 데 기여하고자 합니다. </h2><div data-v-ef7b7b3c><figure data-v-ef7b7b3c><img src=\"" + _imports_0 + "\" style=\"width:500px;\" alt=\"철학\" data-v-ef7b7b3c></figure><p data-v-ef7b7b3c> 창조 역량은 미래 사회가 개인에게 요구하는 핵심역량이다.<br data-v-ef7b7b3c> 창조 역량은 일상, 학업, 진로, 진학, 직업, 삶 전반에서 필요하다.<br data-v-ef7b7b3c><br data-v-ef7b7b3c> 창조 역량은 타고난 재능, 관심, 경험으로 성장한다.<br data-v-ef7b7b3c> 창조 역량은 도전적 활동이 지속되어 진화한 결과이다.<br data-v-ef7b7b3c><br data-v-ef7b7b3c> 창조 역량은 미성숙한 행동과 성숙한 행동의 상호작용 결과이다. <br data-v-ef7b7b3c> 창조 역량은 체계적 진단을 통한 자기 이해에서 시작된다 . </p></div></div></div></div>", 1))
    ])
  ]))
}
}

})